module.exports = __webpack_public_path__ + "static/media/20210212_224212_103_IMG_2274.940c0354.jpg";